import { Typography } from "@mui/material";
import React from "react";
import useNotification from "../../../../hooks/useNotification";
import { NotificationLink } from "../../../../features/message/messageSlice";
import { Link } from "react-router-dom";
import { NotificationDialogBase } from "./NotificationDialogBase";
export { NotificationDialogBase };

type Props = {
  title: string;
  contentText: string;
  confirmText?: string;
  links?: Record<string, NotificationLink>;
  isOpen: boolean;
};

export const NotificationDialog = ({
  title,
  contentText,
  confirmText,
  links,
  isOpen,
}: Props) => {
  const { wipeNotification } = useNotification();

  const renderContent = (
    text: string,
    links?: Record<string, NotificationLink>,
  ) => {
    if (!links || Object.keys(links).length === 0) {
      return <Typography>{text}</Typography>;
    }

    const elements: React.ReactNode[] = [];
    let lastIndex = 0;
    let keyCounter = 0;

    const placeholderPattern = new RegExp(
      Object.keys(links)
        .map((key) => `__${key}__`)
        .join("|"),
      "g",
    );

    text.replace(placeholderPattern, (match, offset) => {
      // Add text before the placeholder
      if (offset > lastIndex) {
        elements.push(text.substring(lastIndex, offset));
      }

      // Extract placeholder name
      const placeholderName = match.replace(/^__|__$/g, "");
      const linkData = links[placeholderName];

      if (linkData) {
        elements.push(
          <Link
            key={`link-${keyCounter++}`}
            to={linkData.href}
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontWeight: 600, display: "block", marginTop: "4px" }}
          >
            {linkData.text}
          </Link>,
        );
      }

      lastIndex = offset + match.length;
      return match; // Return value doesn't matter, we're using side effects
    });

    // Add remaining text after last placeholder
    if (lastIndex < text.length) {
      elements.push(text.substring(lastIndex));
    }

    return <Typography>{elements}</Typography>;
  };

  return (
    <NotificationDialogBase
      open={isOpen}
      onClose={wipeNotification}
      title={title}
      closeLabel={confirmText}
      content={renderContent(contentText, links)}
    />
  );
};
